import ClipboardJS from 'clipboard';
import * as Sentry from '@sentry/nextjs';

export function copyToClipboard(text: string) {
  try {
    ClipboardJS.copy(text, {
      container: document.body
    });
  } catch (err) {
    Sentry.captureException(err);
  }
}
